import { defineStore } from 'pinia'

import type { DisciplineGeneralInfoStore } from './interfaces'

import { actions } from './actions'
import { getters } from './getters'

export const useDisciplineGeneralInfoStore = defineStore('discipline-general-info', {
  state: (): DisciplineGeneralInfoStore => ({
    form: null,
    saving: false,
    activeModal: null,
    mergeIds: [],
  }),
  actions,
  getters,
})
